module.exports = __webpack_public_path__ + "img/inventory2.bd0d80f1.svg";